import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import Typography from 'components/curo-components/common/Typography';
import media from 'styles/media.module.scss';
import styled from 'types/AppTheme';

const PAGE_TITLE = 'Sign your documents and get your loan!';
const PAGE_DESCRIPTION = (
  <>
    <Typography>
      Your loan documents are ready! Please click "Sign Loan Agreement" below to sign your
      documents.
    </Typography>
    <br />
    <Typography type="primary">
      By clicking "Sign Loan Agreement", I understand and agree that Heights Finance will order a
      credit report in connection with this application. This will result in a hard inquiry and may
      impact my credit score.
    </Typography>
  </>
);

const StyledUploadFileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 36px 0px;
  justify-self: flex-start;
  align-items: flex-start;

  @media (max-width: ${media.maxMobile}) {
    margin: 28px 0px;
  }
`;

interface IGeneralStepProps {
  onContinueClick: () => void;
}

const GeneralStep = ({ onContinueClick }: IGeneralStepProps) => {
  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
      <StyledUploadFileWrapper>
        <Button kind="primary" size="form" onClick={onContinueClick}>
          Sign Loan Agreement
        </Button>
      </StyledUploadFileWrapper>
    </>
  );
};

export default GeneralStep;
